<template>
  <div class="max-w-screen-3xl md:w-full shadow-2xl screenWidth" style="">
    <div id="dropdown"/>
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen relative">
        <div style="height: 49px" class="hidden md:flex bg-orfBlue-100 items-center text-white">
          <div class="contentWidth w-full mx-auto flex items-center px-4 md:px-0">
            <HeroIcon name="user-circle" mini class="mr-2 w-7 h-7 fill-white group-hover:fill-orfBlue-100"/>
            <div class="flex gap-2">
              <span class="font-bold uppercase">{{ auth.user.first_name}} {{auth.user.last_name}}</span>
              <span v-if="auth.user.team" class="">{{ auth.user.team.name }}</span>
            </div>
            <Link class="group hidden lg:flex items-center ml-2" href="/logout">
              <div
                class="flex transition-colors 1s ease-in-out items-center mx-1.5 p-1 px-3 text-sm rounded border group bg-transparent hover:bg-red-500 text-orfBlue-100 border-white hover:border-red-500 hover:text-white"
              >
                <HeroIcon name="power" class="mr-1 w-4 h-4 fill-white"
                />
                <div class="text-white text-xs"
                >
                  Abmelden
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div class="fixed sm:relative bg-white flex-col w-full z-50 flex md:flex-shrink-0 items-center border-b border-orfBlue-100">
          <div class="contentWidth w-full mx-auto flex flex-col items-center">
            <div
              class="md:hidden relative flex items-center bg-orfBlue-100 justify-between w-full md:flex-shrink-0 md:justify-center" style="height: 64px"
            >
              <div class="flex items-center justify-start">
                <button type="button" @click="showMenu = !showMenu" class="p-5">
                  <HeroIcon v-if="showMenu" name="times" class="w-6 fill-white"/>
                  <svg v-else class="w-6 h-6 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
                  </svg>
                </button>
                <div v-if="showMenu" class="absolute w-full bg-white p-8 flex flex-col gap-2" style="top: 64px;">
                  <MenuItem url-name="dashboard" url-text="Dashboard" location="/" icon-name="home" :home="true"  @click="showMenu = !showMenu"/>
                  <MenuItem url-name="events" url-text="Meine Termine" location="/events" icon-name="rectangle-stack" @click="showMenu = !showMenu"/>
                  <MenuItem url-name="users" url-text="Mitarbeiter/Innen" location="/users" icon-name="users" :admin="false" @click="showMenu = !showMenu"/>
                  <MenuItem url-name="departments" url-text="Abteilungen" location="/departments" icon-name="flag" :admin="false" @click="showMenu = !showMenu"/>
                  <MenuItem url-name="help" url-text="Hilfe" location="/help" icon-name="question-mark-circle" @click="showMenu = !showMenu"/>
                  <MenuItem v-if="is_dev" url-name="reports" url-text="Feedback" location="/reports" icon-name="chat-bubble-left-ellipsis" :admin="true" @click="showMenu = !showMenu"/>
<!--                  <MenuItem url-name="help" url-text="Hilfe" location="/help" icon-name="help"/>-->
                  <div class="my-2 flex flex-col border-t pt-4">
                    <div class="flex flex-col py-3 px-4">
                      <div class="flex gap-2 flex-wrap italic">
                        <span class="font-bold uppercase">{{auth.user.title_before ? auth.user.title_before + '.' : ''}} {{ auth.user.first_name}} {{auth.user.last_name}} {{auth.user.title_after ? ', ' + auth.user.title_after + '.' : ''}}</span>
                        <span class="">{{ auth.user.username }}</span>
                      </div>
                    </div>
                    <MenuItem url-name="logout" url-text="Abmelden" location="/logout" icon-name="power"/>
                  </div>
                  <hr/>
                  <div class="my-2 mt-4 flex items-center justify-between">
                    <Link href="https://www.orf.at/" class="p-2 hover:border-b">
                      Impressum
                    </Link>
                    <Link href="https://www.orf.at/" class="p-2 border-b border-transparent transition-all 1s ease-in-out hover:border-white">
                      Datenschutz
                    </Link>
                  </div>
                </div>

                <div class="xl:text-2xl md:hidden text-center font-bold text-white capitalize">
                  <Link :href="'/' + activeUrl">{{ getTitle() }}</Link>
                </div>
              </div>
              <loading-button text="Feedback" icon-name="chat-bubble-left-ellipsis" small @click="setShowPopup(true)"/>
              <a href="https://enterprise.orf.at" target="_blank" class="h-full px-5 py-2.5">
                <LogoInverted/>
              </a>
            </div>
            <div
              class="hidden md:flex md:text-md items-center justify-between w-full text-sm px-4 md:px-0 relative" style="min-height: 101px !important;"
            >
              <Link class="md:text-4xl text-center font-bold text-orfBlue-100 items-start sm:items-center flex flex-col sm:flex-row gap-2" href="/">
                <span class="hidden sm:flex uppercase">ORF-Enterprise Office Tool</span>
              </Link>
              <a href="https://enterprise.orf.at" target="_blank">
                <Logo/>
              </a>
            </div>
            <div class="w-full items-center flex-grow h-full hidden lg:flex px-12 relative">
              <MenuItem url-name="dashboard" url-text="Dashboard" location="/" icon-name="home" :home="true" />
              <MenuItem url-name="events" url-text="Meine Termine" location="/events" icon-name="rectangle-stack"/>
              <MenuItem url-name="users" url-text="Mitarbeiter/Innen" location="/users" icon-name="users" :admin="false"/>
              <MenuItem url-name="departments" url-text="Abteilungen" location="/departments" icon-name="flag" :admin="false" @click="showMenu = !showMenu"/>
              <MenuItem url-name="help" url-text="Hilfe" location="/help" icon-name="question-mark-circle" @click="showMenu = !showMenu"/>
              <MenuItem v-if="is_dev" url-name="reports" url-text="Feedback" location="/reports" icon-name="chat-bubble-left-ellipsis" :admin="true" @click="showMenu = !showMenu"/>
              <div class="absolute top-1/2 transform -translate-y-1/2 right-0">
                <loading-button text="Feedback" icon-name="chat-bubble-left-ellipsis" small @click="setShowPopup(true)"/>
              </div>

<!--              <MenuItem url-name="help" url-text="Hilfe" location="/help" icon-name="help"/>-->
            </div>
          </div>
        </div>
        <div class="flex flex-col md:overflow-hidden pt-20 sm:pt-0">
          <div class="md:overflow-y-auto bg-orfGray-100 h-screen" scroll-region>
            <div class="px-4 py-8 md:flex-1 md:px-0 md:py-12 contentWidth w-full mx-auto" style="min-height: 100vh">
              <slot/>
              <div v-if="showPopup" class="absolute top-10 left-0 w-full z-50 h-screen">
                <div class="relative w-full h-full">
                  <div class="absolute bg-orfBlue-100 top-0 left-0 w-full h-screen bg-opacity-20 z-50 flex items-center justify-center" @click="setShowPopup(false)" >
                    <div @click.stop class="flex flex-col bg-white p-8 border-orfBlue-100 shadow-xl relative">
                      <HeroIcon name="x-mark" outline class="w-7 h-7 absolute top-1 right-1 fill-orfBlue-100 text-orfBlue-100 transform hover:scale-125 cursor-pointer transition-transform 0.5s ease-in-out" @click="setShowPopup(false)"/>
                      <h1 class="mb-2 text-center text-gray-500 font-bold">Dein Feedback hilft uns bei der Weiterentwicklung des Tools</h1>
                      <div class="mb-2 text-center text-2xl text-orfBlue-100 font-bold mt-2">Dein Feedback</div>
                      <div @submit.prevent="store" class="flex flex-col items-center">
                        <select-input v-model="reportForm.type" name="type" :pre="null" row :error="reportForm.errors.type" label="Feedback-Typ" class="flex flex-grow items-center w-full whitespace-nowrap gap-4 border-0 mt-2 mb-4">
                          <option :value="null">Bitte auswählen</option>
                          <option value="allgemein">Allgemein</option>
                          <option value="design">Design</option>
                          <option value="bug">Bug</option>
                        </select-input>
                        <textarea-input v-model="reportForm.description" required type="text" name="description" :error="reportForm.errors.description"
                                        class="flex flex-grow items-center w-full whitespace-nowrap gap-4 border-0 mt-2 mb-4"
                                        rows="4"
                                        label="Beschreibung"
                        />
                      </div>
                      <div class="flex flex-col justify-between px-8 py-6 w-full items-center bg-gray-50">
                        <loading-button text="Abschicken" icon-name="save" icon-custom-icon @click="store" :loading="reportForm.processing"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="$page.props.flash.success || ($page.props.flash.error || Object.keys($page.props.errors).length > 0) " class="absolute top-10 left-0 w-full z-50 h-screen pointer-events-none">
                <div class="relative w-full h-full">
                  <flash-messages/>
                </div>
              </div>
            </div>
            <footer class="bg-orfBlue-100 px-8 py-4 text-white">
              <div class="contentWidth w-full mx-auto">
                <a href="#top"><span class="hidden">Nach oben</span></a>
                <div>
                  <div class="border-b flex flex-col sm:flex-row items-center px-2">
                    <div class="flex-grow">
                      <div>
                        <ul class="uppercase flex items-center py-4">
                          <li class="pr-2 border-r">
                            <a href="https://enterprise.orf.at/ihre-buchung/allgemeine-informationen/agb" target="_blank"
                               class="hover:underline"
                            >AGB</a>
                          </li>
                          <li class="px-2 border-r">
                            <a
                              href="https://enterprise.orf.at/ihre-buchung/allgemeine-informationen/allgemeine-einkaufsbedingungen"
                              target="_blank"
                              class="hover:underline"
                            >AEB</a>
                          </li>
                          <li class="px-2 border-r">
                            <a href="https://enterprise.orf.at/kontakt" target="_blank" class="hover:underline"
                            >Kontakt</a>
                          </li>
                          <li class="pl-2">
                            <a href="https://enterprise.orf.at/newsletter" target="_blank" class="hover:underline">Newsletter</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="">
                      <div>
                        <ul class="uppercase flex items-center py-4">
                          <li class="pr-2 border-r">
                            <a href="https://enterprise.orf.at/impressum" target="_blank" class="hover:underline">impressum</a>
                          </li>
                          <li class="pl-2">
                            <a href="https://enterprise.orf.at/datenschutz" target="_blank" class="hover:underline">Datenschutz</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="flex py-4 leading-tight flex-col gap-4 sm:gap-0 sm:flex-row px-2">
                    <address class="flex-grow not-italic" itemscope="" itemtype="http://schema.org/PostalAddress">
                      <strong>ORF-Enterprise GmbH &amp; Co KG</strong>
                      <br>
                      Hugo-Portisch-Gasse 1
                      <br>
                      1136 Wien
                      <br>
                      Österreich
                      <br>
                      Tel.:&nbsp;
                      <a href="tel:+4318707714500" class="font-bold" itemprop="telephone" content="+4318707714500">+43 1
                        87077-14500</a>
                      <br>
                      Mail:&nbsp;
                      <a href="mailto:enterprise@orf.at" class="font-bold" itemprop="email" content="enterprise@orf.at"
                      >enterprise@orf.at</a>
                    </address>
                    <div class="">
                      <strong>Rechnungsadresse:</strong>
                      <br>
                      ORF-Enterprise GmbH &amp; Co KG
                      <br>
                      Hugo-Portisch-Gasse 1
                      <br>
                      1136 Wien
                      <br>
                      Österreich
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import MenuItem from "@/Shared/MenuItem.vue";
import Logo from "@/Shared/Logo.vue"
import LogoInverted from "@/Shared/LogoInverted.vue"
import LoadingButton from "@/Shared/LoadingButton.vue";
import TextareaInput from "@/Shared/TextareaInput.vue";
import SelectInput from "@/Shared/SelectInput.vue";

export default {
  components: {
    SelectInput,
    TextareaInput,
    LoadingButton,
    MenuItem,
    Dropdown,
    FlashMessages,
    HeroIcon,
    Link,
    MainMenu,
    Logo,
    LogoInverted,
  },
  props: {
    auth: Object,
    data: String,
    is_admin: Boolean,
    is_dev: Boolean,
  },
  data() {
    return {
      activeUrl: '',
      showMenu: false,
      reportForm: this.$inertia.form({
        email: '',
        description: '',
        type: null
      }),
      showPopup: false,
    }
  },
  methods: {
    store(){
      this.reportForm.post('/reports', {onSuccess: () => {
        this.reportForm.email = '';
        this.reportForm.description = '';
        this.reportForm.type = null;
        this.showPopup = false;
      }})
    },
    setShowPopup(value){
      this.showPopup = value
    },
    isUrl(...urls) {
      let currentUrl = ''
      if (this.$page.url.indexOf('/?') != -1) {
        currentUrl = this.$page.url.substr(0, this.$page.url.indexOf('/?'))
      } else {
        currentUrl = this.$page.url.substr(1)
      }
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
    getTitle() {
      let title = ''
      switch (this.activeUrl.value) {
        case '':
          return 'Editor'
          break
        case 'myOrders':
          return 'Meine Aufträge'
          break
        case 'orders':
          return 'Alle Aufträge'
          break
        case 'users':
          return 'Alle User'
          break
        case 'teams':
          return 'Alle Teams'
          break
        case 'departments':
          return 'Alle Abteilungen'
          break
        case 'help':
          return 'Hilfe'
          break
        case 'feedback':
          return 'Feedback'
          break
        default:
          return ''
          break
      }
    }
  }
}
</script>
<style>
input::-webkit-color-swatch {
  border-radius: 50%;
  border: none;
}
#nprogress {
  pointer-events: none;
}
#nprogress::before {
  content: 'Loading';
  position: fixed;
  top: calc(50% + 70px);
  left:50%;
  font-weight: bold;
  color: #0f1f5d;
  -webkit-transform: translateX(calc(-50% - 15px));
  -ms-transform: translateX(calc(-50% - 15px));
  transform: translateX(calc(-50% - 15px));
  z-index: 1032;
}

#nprogress::after {
    content: '';
    position: fixed;
    top: calc(50% + 77px);
    left:50%;
    color: #0f1f5d;
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
    z-index: 1032;
    width: 30px;
    aspect-ratio: 4;
    background: radial-gradient(circle closest-side,#0f1f5d 90%,#0000) 0/calc(100%/3) 100% space;
    clip-path: inset(0 100% 0 0);
    animation: d1 2s steps(4) infinite;
}

@keyframes d1 {to{clip-path: inset(0 -34% 0 0)}}

#nprogress .bar {
  background: #d32824;
  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
}

#nprogress .peg {
  display: block;
  position: absolute;
  right: 0;
  width: 100px;
  height: 100%;
  box-shadow: 0 0 10px #29d, 0 0 5px #29d;
  opacity: 0;
  -webkit-transform: rotate(3deg) translate(0, -4px);
  -ms-transform: rotate(3deg) translate(0, -4px);
  transform: rotate(3deg) translate(0, -4px)
}

#nprogress .spinner {
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1030;
  width: 100vw;
  height: 100vh;
  background: rgba(255,255,255,0.5);
  top: 0;
  left: 0;
}

#nprogress .spinner-icon {
  width: 70px;
  height: 70px;
  box-sizing: border-box;
  border: 3px solid transparent;
  border-top-color: #0f1f5d;
  border-left-color: #0f1f5d;
  border-radius: 50%;
  -webkit-animation: nprogress-spinner 750ms linear infinite;
  animation: nprogress-spinner 750ms linear infinite
}

.nprogress-custom-parent {
  overflow: hidden;
  position: relative
}

.nprogress-custom-parent #nprogress .bar,
.nprogress-custom-parent #nprogress .spinner {
  position: absolute
}

@-webkit-keyframes nprogress-spinner {
  0% {
    -webkit-transform: rotate(0deg)
  }

  100% {
    -webkit-transform: rotate(360deg)
  }
}

@keyframes nprogress-spinner {
  0% {
    transform: rotate(0deg)
  }

  100% {
    transform: rotate(360deg)
  }
}
</style>
